interface CarouselMarkProps {
  size?: number
  className?: string
}

const WEDGES = [
  [12, 24, 13.52, 16.35],
  [13.52, 16.35, 17.86, 9.86],
  [17.86, 9.86, 24.35, 5.52],
  [24.35, 5.52, 32, 4],
  [32, 4, 39.65, 5.52],
  [39.65, 5.52, 46.14, 9.86],
  [46.14, 9.86, 50.48, 16.35],
  [50.48, 16.35, 52, 24],
]

const ROSE = '#e11d48'
const AMBER = '#f59e0b'
const TEAL = '#0f766e'

/** Isotipo propio de la tienda: parasol de carrusel geométrico, sin personajes ni fotografías. */
export function CarouselMark({ size = 32, className }: CarouselMarkProps) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
      <ellipse cx="32" cy="55" rx="11" ry="2.5" fill={TEAL} opacity="0.18" />
      <rect x="29.5" y="24" width="5" height="27" rx="2.5" fill={TEAL} />
      {WEDGES.map(([x1, y1, x2, y2], i) => (
        <path key={i} d={`M32 24 L${x1} ${y1} L${x2} ${y2} Z`} fill={i % 2 === 0 ? ROSE : AMBER} />
      ))}
      <circle cx="20" cy="24" r="1.6" fill="#fff8f0" />
      <circle cx="32" cy="24" r="1.6" fill="#fff8f0" />
      <circle cx="44" cy="24" r="1.6" fill="#fff8f0" />
      <circle cx="32" cy="4" r="3" fill={TEAL} />
    </svg>
  )
}
